import { useMemo } from 'react';
import { generateUploadFile } from 'ui';
import { images } from 'common/utils';

const DEFAULT_HERO_IMAGE_ID = 'default-reminder-cover-photo';

export const useGenerateDefaultReminderHeroImage = () =>
  useMemo(
    () =>
      generateUploadFile({
        response: { id: DEFAULT_HERO_IMAGE_ID, url: images.default.reminderCoverPhoto },
      }),
    [],
  );
